import { useEffect, useState } from 'react';
import 'tailwindcss/tailwind.css';

function Banner() {
  const [showFloatingBanner, setShowFloatingBanner] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 0) {
        setShowFloatingBanner(false);
      } else {
        setShowFloatingBanner(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Simula la carga de la imagen
  useEffect(() => {
    const img = new Image();
    img.src = require('../../Imagenes/banner.png');
    img.onload = () => {
      setLoading(false);
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center font-great-vibes text-verde1 text-2xl h-screen ">
          {/* Puedes personalizar este loader */}
          <p>Cargando...</p>
        </div>
      ) : (
        <div 
          className={`fixed top-0 left-0 right-0 ${showFloatingBanner ? "" : "hidden"} overflow-hidden z-50`} 
          style={{ height: '100vh', width: '100vw' }} // Asegura que el contenedor ocupe toda la pantalla
        >
          {/* Imagen de fondo con superposición */}
          <div 
            className="bg-cover relative h-full w-full flex items-center justify-center z-50" 
            style={{ 
              backgroundImage: `url(${require('../../Imagenes/banner.png')})`, 
              backgroundPosition: 'center', 
              backgroundSize: 'cover', // Asegura que la imagen ocupe toda la pantalla
              backgroundRepeat: 'no-repeat',
            }}
          >
            {/* Div para aplicar el filtro de oscurecimiento 
            <div className="absolute inset-0 bg-black opacity-40"></div>*/}
            
            {/* Contenido centrado dentro del círculo */}
            <div className="relative flex flex-col items-center text-verde1 z-10">
              <h1 className="text-8xl font-atentamente mb-4">Betiana</h1>
              <h1 className="text-8xl font-atentamente mb-4">&</h1>
              <h1 className="text-8xl font-atentamente">Renzo</h1>
             <h1 className="text-2xl font-Libre-Baskerville mt-10">¡Nos casamos!</h1>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Banner;









